var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReturn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3767 12H7.62332M16.3767 12C16.4117 12 16.438 12.0289 16.4312 12.0598L15.512 16.1961C15.4081 16.6636 14.9521 17 14.4224 17H9.57756C9.04791 17 8.5919 16.6636 8.48803 16.1961L7.56885 12.0598C7.56197 12.0289 7.58826 12 7.62332 12M16.3767 12H16.4444M7.62332 12H7.55556M7 12H7.55556M7.55556 12L9.22222 9.00002M16.4444 12H17M16.4444 12L14.7778 9.00002M1 12C1 14.5843 1.90985 17.086 3.56999 19.0665C5.23012 21.047 7.53453 22.3797 10.0791 22.831C12.6236 23.2823 15.2458 22.8233 17.4857 21.5345C19.7257 20.2457 21.4404 18.2095 22.3291 15.7828C23.2178 13.3562 23.2238 10.6942 22.346 8.26358C21.4682 5.83299 19.7626 3.78905 17.5285 2.49024C15.2943 1.19143 12.6742 0.720671 10.1277 1.16054C7.58115 1.6004 5.27078 2.9228 3.60178 4.89581M3 1.00002V5.29002C3 5.35077 3.04994 5.40002 3.11155 5.40002H7.46207",
    stroke: "#F97066",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.fd088370f6dbc5bcc6b22992d64ff24e.svg";
export { ForwardRef as ReactComponent };